export enum FnolFlowPages {
  REPORT_CONFIRMATION,
  REPAIR_INFO,
  REPAIR_SEARCH,
  REPAIR_CONFIRMATION,
  PHOTOS_INFO,
  PHOTOS_UPLOAD,
  PHOTOS_CONFIRMATION,
  RENTAL_INFO,
  RENTAL_SEARCH,
  RENTAL_FINALIZE,
  RENTAL_CONFIRMATION
}

export enum FnolFlowStepTitles {
  REPORT = 'Report',
  REPAIR = 'Repair',
  RENTAL = 'Rental',
  PHOTOS = 'Photos'
}
